import React, { useContext, useMemo } from 'react';
import { ConfigContext } from '../../../../Contexts/ConfigContext';
import CheckboxInput from '../../../../Components/CheckBoxInput';
import DropDownMultiple from '../../../../Components/DropDownMultiple';
import PageHeading from '../../../../Components/PageHeading';

//mui imports====
import { Grid } from '@mui/material';
import useCommonStyles from '../../../../commonStyles';
import Paper from '@mui/material/Paper';
import { COUNTRY_CODE_MAP } from '../../../../core/constants';

//===============

const BgRequestConfig = ({ keyData, featureDescription }) => {
	const commonStyleClasses = useCommonStyles();
	const { rawConfig, updateRawConfig } = useContext(ConfigContext);
	const countryListKey = keyData + '.bgWhitelistedCountries';

	/**
	 * Generates a list of country names with their codes for dropdown options.
	 *
	 * @returns {string[]} Array of formatted country names with codes (e.g., "India (IN)")
	 */
	const getAllCountryOptions = useMemo(() => {
		const countryCodes = Object.entries(COUNTRY_CODE_MAP);

		if (countryCodes.length === 0) {
			return [];
		}

		const mappingCountryCodesAndCountryNames = countryCodes.map(
			([code, name]) => `${name} (${code})`
		);
		return mappingCountryCodesAndCountryNames;
	}, []);

	/**
	 * Retrieves the currently selected countries from the config and formats them.
	 *
	 * @returns {string[]} Array of formatted selected countries (e.g., "India (IN)")
	 */
	const getSelectedCountryOptions = useMemo(() => {
		const selectedCountries = rawConfig[countryListKey] || [];
		return selectedCountries.map((code) => `${COUNTRY_CODE_MAP[code]} (${code})`);
	}, [rawConfig]);

	/**
	 * Updates the config when the country list selection changes
	 * Handles both individual and bulk country selections
	 *
	 * @param {string[]} selectedValues - Array of selected country strings (e.g., "India (IN)")
	 */
	const updateCountryListConfig = (selectedValues) => {
		if (!Array.isArray(selectedValues)) {
			return;
		}

		const deepCloneRawConfig = structuredClone(rawConfig);

		const selectedCountryCodes = selectedValues.map((val) => {
			// This code picks out the country code from each item in the selectedValues list
			// Each item looks like - Country Name (CODE) , for example, "India (IN)"
			// Use a regular expression to extract the country code from the value
			// The expected format is something like: "India (IN)", "United States (US)"
			// The regex \((\w+)\)$ matches the last set of characters inside parentheses at the end of the string
			const match = val.match(/\((\w+)\)$/);

			// If there's a match, return the country code (e.g., "IN", "US"), otherwise return null
			return match ? match[1] : null;
		});

		updateRawConfig({
			...deepCloneRawConfig,
			[countryListKey]: selectedCountryCodes
		});
	};

	return (
		<Paper className={commonStyleClasses.mainPagePaperMarginStyle}>
			<PageHeading
				headingName="Bg Request"
				headingPath={['Dashboard', 'Framerate', 'Experiments', 'Bg Request']}
				description="Manage Bg Request Configuration"
				showInfoButton={true}
				infoMessage={featureDescription}
			/>
			<Grid container spacing={0} style={{ marginTop: '4rem', marginLeft: '5rem', width: '90%' }}>
				<Grid item xs={4} style={{ marginTop: '3rem' }}>
					<CheckboxInput
						keyData={keyData + '.enabled'}
						label="Enabled"
						disabled={false}
						defaultChecked={false}
						object={rawConfig}
						updateObject={updateRawConfig}
					/>
				</Grid>
				<Grid item xs={4}>
					<DropDownMultiple
						keyData={keyData + '.bgWhitelistedCountries'}
						label="Bg White listed Countries"
						isObjectEditor={false}
						list={getAllCountryOptions}
						directValue={getSelectedCountryOptions}
						disabled={!rawConfig[keyData + '.enabled']}
						updateDirectValue={updateCountryListConfig}
					/>
				</Grid>
			</Grid>
		</Paper>
	);
};

export default BgRequestConfig;
